import { Injectable } from '@angular/core';

@Injectable()
export class InAppService {

  public shouldDisplayInApp(inAppId: string): boolean {
    const visitedScreenIds = InAppService.getVisitedScreenIds();
    return !this.wasInAppDisplayed(visitedScreenIds, inAppId);
  }

  public markInAppAsDisplayed(inAppId: string) {
    const visitedScreenIds = InAppService.getVisitedScreenIds();

    window.localStorage.setItem('welcomeScreens', JSON.stringify([...visitedScreenIds, inAppId]));
  }

  private wasInAppDisplayed(visitedScreenIds: string[], inAppId: string) {
    return visitedScreenIds.find((screenId) => screenId === inAppId) !== undefined;
  }

  private static getVisitedScreenIds(): string[] {
    return JSON.parse(window.localStorage.getItem('welcomeScreens')) || [];
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/in-app-service/in-app-service.ts